import { render } from "./UiFormEmail.vue?vue&type=template&id=3252c7b2"
import script from "./UiFormEmail.vue?vue&type=script&lang=js"
export * from "./UiFormEmail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__